import React, { Component } from 'react';
import {connect} from "react-redux";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

// Component
import Chart from '../../../../home/helper/component/Chart/Chart.js';
import AssetList from '../../../../home/helper/component/MyAsset/AssetList.js';
import BookedAssetList from '../../../../home/helper/component/BookedAsset/BookedAssetList.js';
import IncomingMessageList from '../../../../home/helper/component/IncomingMessage/IncomingMessageList.js';
//Icon
import iconMaping from '../../../../utils/IconMaping.js';
import '../../../assets/custome/css/home.css';
import windowStop from '../../../../utils/windowStop.js';

class HomeUserScreen extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTab     : 1,
      firstTimeLoad: {
        1 : true,
      },
      totalMyAsset  : 0,
      summaryTab    : 1,
    };

    // Tab
    this.toggleTab = this.toggleTab.bind(this);
  }

  toggleTab(tab) {
    if(this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        firstTimeLoad: {
          ...this.state.firstTimeLoad,
          [tab]: true
        }
      })
    }
  }

  setSummaryTab(summaryTab){
    this.setState({ 
      activeTab : 1,
      summaryTab,
    })
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
    windowStop()
  }

  render() {
    const {activeTab, firstTimeLoad} = this.state

    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-12">
            <Chart SetSummaryTab={this.setSummaryTab.bind(this)} UserReducer={this.props.UserReducer}></Chart>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <Nav tabs>
              <NavItem>
                <NavLink className={classnames({ active: activeTab === 1 })} onClick={() => { this.toggleTab(1); }} >
                  <i className={iconMaping.AVICON_DIAMOND}></i> My Assets/Tools &nbsp;
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: activeTab === 2 })} onClick={() => { this.toggleTab(2); }} >
                  <i className="icon-calendar"></i> Booked Assets/Tools &nbsp;
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: activeTab === 3 })} onClick={() => { this.toggleTab(3); }} >
                  <i className="icon-envelope-letter"></i> Re-Assign Messages &nbsp;{this.props.confirmation.CounterElement}
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent className="" activeTab={activeTab}>
              {/* Tab 1 */}
              <TabPane tabId={1}>
                <div className="">
                  {firstTimeLoad[1] &&
                    <AssetList 
                      {...this.props}
                      onRef = {ref => (this.assetList = ref)}
                      SummaryTab={this.state.summaryTab} 
                      UserReducer={this.props.UserReducer}
                    />
                  }
                </div>
              </TabPane>

              {/*  Tab 2 */}
              <TabPane tabId={2}>
                <div className="">
                  {firstTimeLoad[2] &&
                    <BookedAssetList 
                      {...this.props}
                      UserReducer={this.props.UserReducer} 
                    />
                  }
                </div>
              </TabPane>

              {/* Tab 3 */}
              <TabPane tabId={3}>
                <div className="">
                  {/**
                  |--------------------------------------------------
                  | Date : 28-maret-2019 By:Danan W
                  |
                  | Don't use method FirstTimeLoad to IncomingMessageList.
                  | because he must load data counter incoming message in tab.
                  | FirstTimeLoad is use for load data first time only and don't recommend to this component.
                  | if FirstTimeLoad is active, IncomingMessageList can't filter incoming, outcoming. unconfirmed or etc
                  |--------------------------------------------------
                  */}

                  <IncomingMessageList 
                    {...this.props}
                    self={this} 
                    onRef={ref => (this.incomingMessageList = ref)}
                  />
                  
                </div>
              </TabPane>

            </TabContent>
          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      UserReducer     : state.UserReducer,
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
        RunRedux: (data) => {
            dispatch(data);
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeUserScreen);



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/home/home.js